import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { getRequest, finishRequest } from "../../../../../services/manager/admin/requests.service";
import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { FaFilePdf, FaReceipt } from "react-icons/fa";
import { MdOutlineContentCopy } from "react-icons/md";
import { formatReal } from "../../../../../../helpers";

import { toast } from "react-toastify";
import { Messages } from 'primereact/messages';
import { Button, Container, Row, Col, Spinner, OverlayTrigger, Tooltip, Card, Form } from "react-bootstrap";
import { ContentHeader, ContentBody, CardBody } from "./styles"
import { Modal } from "../../../../../components/modal";
import Error from "../../../../../components/Error";

const validationSchema = Yup.object({
  voucher: Yup.mixed().nullable().required("Adicione um comprovante de transferência para finalizar a solicitação"),
}).required();

export const RequestDetails = (): JSX.Element => {
  const history = useHistory();
  const { t: translation } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { handleSubmit, setValue, clearErrors, formState: { errors: errors }} = useForm({ resolver: yupResolver(validationSchema) });

  const voucherRef = useRef<any>(null);
  const fileInput = useRef<any>(null);
  
  const [invoice, setInvoice] = useState("")
  const [showInvoice, setShowInvoice] = useState<boolean>(false)
  const [voucher, setVoucher] = useState("")
  const [showVoucher, setShowVoucher] = useState<boolean>(false)

  const [request, setRequest] = useState<any>()
  const [loading, setLoading] = useState<boolean>(true);

  const handleChangePhoto = (e: any) => {
    voucherRef.current.clear();
    setTimeout(() => {
      setValue('voucher', e.target.files[0])
      clearErrors('voucher')
      voucherRef.current.show({
        severity: 'info', sticky: true, content: (
          <div className="">{e.target.files[0].name}</div>
        )
      });
    }, 170)
  };
  
  const handleShowInvoice = () => {
    setInvoice("")
    setVoucher("")
    if (request.files.length > 0) {
      request.files.map((item: any) => {
        if (item.type === "Nota Fiscal") {
          setInvoice(item.file)
        }
      })
    }
    setShowInvoice(true)
  }

  const handleShowVoucher = () => {
    setVoucher("")
    setInvoice("")
    if (request.files.length > 0) {
      request.files.map((item: any) => {
        if (item.type === "Comprovante de Pagamento") {
          setVoucher(item.file)
        }
      })
    }
    setShowVoucher(true)
  }

  const handleCopyButton = (itemToCopy: any) => {
    if (itemToCopy === 'agency') {
      navigator.clipboard.writeText(request.account_bank?.agency)
      toast.success('Agência copiada!', { autoClose: 1500 });
    } else if (itemToCopy === 'pix') {
      navigator.clipboard.writeText(request.account_bank?.pix)
      toast.success('Chave PIX copiada!', { autoClose: 1500 });
    } else {
      navigator.clipboard.writeText(request.account_bank?.account)
      toast.success('Conta copiada!', { autoClose: 1500 });
    }
  }

  const onSubmit = (formData: any) => {
    let obj = {
      file: formData.voucher,
      type: 1
    }

    finishRequest(id, obj).then(() => {
      toast.success('Solicitação finalizada com sucesso!')
      history.push('/manager/admin/requests')
    })
  };

  useEffect(() => {
    getRequest(id).then((response) => {
      setRequest(response);
      setLoading(false);
    })
  }, [])

  if (loading) {
    return (
      <div className="loading-container mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <Container fluid>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ContentHeader>
          <Row>
            <Col>
              <div className="title">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{translation('back')}</Tooltip>}
                >
                  <span>
                    <HiOutlineArrowCircleLeft className="mr-1 mb-1 cursor-pointer" onClick={() => history.push('/manager/admin/requests')}/>                          
                  </span>
                </OverlayTrigger>
                {translation('manager.requests.detailsRequest')}
              </div>
            </Col>
            <Col className="text-end">
              {
                request.status === 1 &&
                <Button className="mb-1" type="submit">
                  {translation('manager.requests.finishRequest')}
                </Button>
              }
            </Col>
          </Row>
        </ContentHeader>
        <ContentBody>
          <Row>
            <h5 className="mt-4 mb-4 text-black"><b>{translation('manager.requests.requestedAmount')}</b>: <b>R$ {formatReal(request.value.toFixed(2))}</b></h5>
            <Col xs={12}>
              <Row>
                <Col md={6} xxl={5}>
                  <Card style={{ borderRadius: '8px', border: '0.5px solid #efefef', filter: 'drop-shadow(0px 2px 8px rgba(51, 51, 51, 0.15))' }}>
                    <CardBody>
                      <h6 className="mt-2 mb-4"><b>{translation('manager.withdrawal.accountData')}</b></h6>
                      <p>{translation('manager.withdrawal.bank')}: {request.account_bank?.bank_number} - {request.account_bank?.bank}</p>
                      <Row>
                        <Col md={6}>
                          <Row>
                            <Col xs={7}>
                              <p className="mb-1"><b>{translation('manager.withdrawal.agency')}:</b> {request.account_bank?.agency}</p>
                              <p><b>{translation('manager.withdrawal.account')}:</b> {request.account_bank?.account}</p>
                            </Col>
                            <Col xs={5}>
                              <OverlayTrigger placement="top" overlay={<Tooltip>{translation('manager.withdrawal.copyAccount')}</Tooltip>}>
                                <span className="cursor-pointer">
                                  <MdOutlineContentCopy onClick={() => handleCopyButton('agency')}/> <br/>
                                </span>
                              </OverlayTrigger>

                              <OverlayTrigger placement="top" overlay={<Tooltip>{translation('manager.withdrawal.copyAgency')}</Tooltip>}>
                                <span className="cursor-pointer">
                                  <MdOutlineContentCopy onClick={() => handleCopyButton('account')}/>
                                </span>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <p className="mb-1"><b>{translation('manager.withdrawal.accountType')}:</b> {request.account_bank?.type}</p>
                          <Row>
                            <Col xs={10}>
                              <p><b>{translation('manager.withdrawal.pixKey')}:</b> {request.account_bank?.pix ? request.account_bank?.pix : 'Não Informado'}</p>
                            </Col>
                            {
                              request.account_bank?.pix &&
                              <Col xs={2} className="p-0">
                                <OverlayTrigger placement="top" overlay={<Tooltip>{translation('manager.withdrawal.copyPix')}</Tooltip>}>
                                  <span className="cursor-pointer">
                                    <MdOutlineContentCopy onClick={() => handleCopyButton('pix')}/>
                                  </span>
                                </OverlayTrigger>
                              </Col>
                            }
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  <Col xs={12} className="mt-3 text-blueberry">
                    <span className="cursor-pointer" onClick={() => handleShowInvoice()}>
                      {translation('manager.withdrawal.viewInvoice')}&nbsp; <FaFilePdf/>
                    </span>                  
                  </Col>

                  {
                    request.status === 2 ? (
                    <Col xs={12} className="mt-2 text-blueberry">
                      <span className="cursor-pointer" onClick={() => handleShowVoucher()}>
                        {translation('manager.withdrawal.viewVoucher')}&nbsp; <FaReceipt/>
                      </span>
                    </Col>
                    ) : (
                      <Col xs={12}>
                        <h6 className="mb-3 mt-3 text-black"><b>{translation('manager.requests.addVoucher')}</b></h6>
                        <div><Button variant="outline-primary" onClick={() => fileInput?.current.click()}>{translation('manager.button.add')}</Button></div>
                        
                        <Form.Group className="">
                          <Form.Control ref={fileInput} className="d-none" type="file" accept=".png,.jpg,.jpeg,.pdf" name="voucher" onChange={(e: any) => handleChangePhoto(e)}/>
                        </Form.Group>
                        <Messages ref={voucherRef} onRemove={() => setValue('voucher', null)} />

                        {errors.voucher ? (<div className="w-100"> <Error>{errors.voucher?.message}</Error> </div>) : ""}
                      </Col>
                    )
                  }
                </Col>
                <Col md={6} xxl={5}>
                  <Card style={{ borderRadius: '8px', border: '0.5px solid #efefef', filter: 'drop-shadow(0px 2px 8px rgba(51, 51, 51, 0.15))' }}>
                    <CardBody>
                      <h6 className="mt-3 mb-4"><b>{translation('manager.requests.userData')}</b></h6>
                      <p>{translation('manager.requests.userName')}: {request.profile?.name}</p>
                      <p>{translation('manager.requests.responsible')}: {request.profile?.responsible}</p>
                      <p>{translation('manager.requests.cnpj')}: {request.profile?.cnpj}</p>

                      <h6 className="mt-5 mb-4"><b>{translation('manager.requests.address')}</b></h6>
                      <p>{translation('manager.requests.cep')}: {request.address?.cep}</p>
                      <p>{request.address?.public_space}, {request.address?.number} - {request.address?.district}</p>
                      <p>{request.address?.city} - {request.address?.state}</p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </ContentBody>
      </Form>

      <Modal headerTitle={translation('manager.withdrawal.viewInvoice')} variant="form-modal-default" show={showInvoice} loading={false} onHide={() => setShowInvoice(false)}>
        {
          invoice ? (
            <img width="100%" height="100%" src={invoice} alt="" />
          ) : (
            <h5 className="text-center">Não foi anexada uma nota fiscal</h5>
          )
        }
      </Modal>

      <Modal headerTitle={translation('manager.withdrawal.viewVoucher')} variant="form-modal-default" show={showVoucher} loading={false} onHide={() => setShowVoucher(false)}>
        {
          invoice ? (
            <img width="100%" height="100%" src={voucher} alt="" />
          ) : (
            <h5 className="text-center">Não foi anexado nenhum comprovante</h5>
          )
        }
      </Modal>
    </Container>
  )
}